"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * Higher Order Component that renders the wrapped component with the given key (derived from its
 * props), which allows us to easily "reset" a component if certain props change.
 * @param component
 * @param getKey
 */
function KeyOn(component, getKey) {
    var _a, _b;
    var componentName = (_b = (_a = component.displayName, (_a !== null && _a !== void 0 ? _a : component.name)), (_b !== null && _b !== void 0 ? _b : 'unknown'));
    var displayName = "KeyOn(" + componentName + ")";
    var hoc = function (props) {
        var key = getKey(props);
        return React.createElement(component, __assign(__assign({}, props), { key: key }));
    };
    hoc.displayName = displayName;
    return hoc;
}
exports.KeyOn = KeyOn;
//# sourceMappingURL=KeyOn.js.map